import { render, staticRenderFns } from "./RMAConfigLandingPage.vue?vue&type=template&id=43202931&scoped=true&"
import script from "./RMAConfigLandingPage.vue?vue&type=script&lang=js&"
export * from "./RMAConfigLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./RMAConfigLandingPage.vue?vue&type=style&index=0&id=43202931&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43202931",
  null
  
)

export default component.exports